export default "__VITE_ASSET__DlXikpnP__"